<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="commodityId ? '修改商品' : '新增商品'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="commodityInfo"
        label-position="right"
        label-width="100px"
        ref="editFormRef"
        v-loading="loading"
        :rules="{
          sysFileIdList: $ruleUtil.array('商品图片', '上传', 0, 10),
          name: $ruleUtil.simple({
            fieldName: '商品名称',
            required: true,
            max: 50,
          }),
          commodityCategoryId: $ruleUtil.simple({
            fieldName: '商品分类',
            handleType: '选择',
            required: true,
          }),
          color: $ruleUtil.simple({
            fieldName: '颜色',
            required: true,
            max: 20,
          }),
          unit: $ruleUtil.simple({
            fieldName: '单位',
            required: true,
            max: 20,
          }),
          supplierId: $ruleUtil.simple({
            fieldName: '供应商',
            handleType: '选择',
            required: true,
          }),
          specAddNewPojoList: $ruleUtil.array('商品规格', '填写', 1),
        }"
        v-if="commodityInfo"
      >
        <el-form-item label="商品图片" class="fm-mt-10" prop="sysFileIdList">
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in imageList"
            :key="index"
          >
            <el-image
              :id="'commodityImage' + index"
              :src="file.url"
              :preview-src-list="imageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="commodityFilePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="commodityFileDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadCommodityImage + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="imageList"
            :show-file-list="false"
            :on-change="commodityFileChange"
            :on-success="commodityFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="imageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="commodityInfo.name"
            style="width: 400px"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="commodityCategoryId">
          <CommodityCategorySelectDialog
            v-model="commodityCategoryInfo"
            @select="selectCommodityCategory"
          ></CommodityCategorySelectDialog>
        </el-form-item>
        <el-form-item label="颜色" prop="color">
          <el-input
            v-model="commodityInfo.color"
            style="width: 400px"
            placeholder="请输入商品颜色"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input
            v-model="commodityInfo.unit"
            style="width: 400px"
            placeholder="请输入商品单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <SupplierSelect
            :value="supplierInfo"
            @select="selectSupplier"
          ></SupplierSelect>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="commodityInfo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品规格" prop="specAddNewPojoList">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="
                commodityInfo.specAddNewPojoList &&
                commodityInfo.specAddNewPojoList.length > 0
              "
            >
              {{
                "共 " + commodityInfo.specAddNewPojoList.length + " 个商品规格"
              }}
            </p>
            <span v-fmtype="'error'" v-else>未添加商品规格</span>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="showSpecAddNewPopup"
              >新增规格</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="commodityInfo.specAddNewPojoList || []"
          stripe
          max-height="500px"
          style="width: 100%"
          :row-key="(row) => Math.random()"
        >
          <el-table-column
            label="规格图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage :commodity="scope.row"></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            label="规格信息"
            min-width="200"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.4em">
                <div style="font-size: 1.1em">
                  {{ "规格名称：" + scope.row.specName }}
                </div>
                <div class="fm-mt-5">
                  {{ "条码：" + (scope.row.barCode || "—") }}
                </div>
                <span v-fmtype="'success'" v-if="scope.row.inProduction"
                  >在产</span
                >
                <span v-fmtype="'danger'" v-else>已停产</span>
                <span v-fmtype="'danger'" v-if="scope.row.frozen">已冻结</span>
                <span v-fmtype="'success'" v-else>未冻结</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="可用库存"
            width="150"
            align="center"
            header-align="center"
          >
            <el-tooltip slot="header" placement="top">
              <div slot="content">
                <div style="font-weight: bold">商品规格库存说明</div>
                虚拟库存：商场加库房一共有的实际产品库存量，包含已销售但未出库的商品数量<br />
                可用库存：可销售库存数量，不包含未出库的商品数量<br />
                计算公式：可用库存 = 虚拟库存 - 待出库数 - 出库中数量 -
                报损中数量 - 已报损数量
              </div>
              <span>
                <i class="el-icon-question"></i>
                可用库存
              </span>
            </el-tooltip>
            <template slot-scope="scope">
              {{ scope.row.id ? scope.row.availableQuantity : "———" }}
            </template>
          </el-table-column>
          <el-table-column
            label="虚拟库存"
            width="150"
            align="center"
            header-align="center"
          >
            <el-tooltip slot="header" placement="top">
              <div slot="content">
                <div style="font-weight: bold">商品规格库存说明</div>
                虚拟库存：商场加库房一共有的实际产品库存量，包含已销售但未出库的商品数量<br />
                可用库存：可销售库存数量，不包含未出库的商品数量<br />
                计算公式：可用库存 = 虚拟库存 - 待出库数 - 出库中数量 -
                报损中数量 - 已报损数量
              </div>
              <span>
                <i class="el-icon-question"></i>
                可用库存
              </span>
            </el-tooltip>
            <template slot-scope="scope">
              {{ scope.row.id ? scope.row.fictitiousQuantity : "———" }}
            </template>
          </el-table-column>

          <el-table-column
            label="现有库存"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.id ? "———" : scope.row.nowQuantity }}
            </template>
          </el-table-column>

          <el-table-column
            label="待入库/入库中"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.id
                  ? scope.row.toBeInputQuantity +
                    " / " +
                    scope.row.inputingQuantity
                  : "———"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="待出库/出库中"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.id
                  ? scope.row.toBeOutputQuantity +
                    " / " +
                    scope.row.outputingQuantity
                  : "———"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="报损中/已报损"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.id
                  ? scope.row.lossingQuantity +
                    " / " +
                    scope.row.completedLossQuantity
                  : "———"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="调拨中"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.transerQuantity }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="$jsTool.currentUserCanSeePrice()"
            label="采购价"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.retailPrice"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            label="批发价"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.tradePrice"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            label="零售价"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.buyingPrice"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            label="配送费"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.distributionPrice"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            label="拓展字段"
            width="200"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.extFieldValueAddNewPojoList &&
                  scope.row.extFieldValueAddNewPojoList.length > 0
                "
              >
                <div
                  v-for="(item, index) in scope.row.extFieldValueAddNewPojoList"
                  :key="index"
                  class="fm-mr-10"
                  style="
                    float: left;
                    color: var(--fm-info-color);
                    font-size: 0.9em;
                  "
                >
                  {{
                    item.label +
                    "：" +
                    (item.value == null ? "-" : item.value) +
                    ";"
                  }}
                </div>
              </template>
              <span v-else>———</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            header-align="center"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                @click.native.stop="showSpecEditPopup(scope.row, scope.$index)"
                type="text"
                icon="el-icon-edit"
              >
                编辑
              </el-button>
              <el-button
                @click.native.stop="deleteSpec(scope.row, scope.$index)"
                type="text"
                icon="el-icon-delete"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="销售套装" class="fm-mt-10">
          <div class="fm-flex">
            <div class="fm-flex" style="height: 32px">
              <el-switch
                v-model="hasSaleSuit"
                :active-color="$jsTool.getColor('success')"
                :inactive-color="$jsTool.getColor('warning')"
                @change="handleHasSaleSuit"
              >
              </el-switch>
            </div>
            <div class="fm-flex fm-margin-left-10" v-if="hasSaleSuit">
              <p v-fmtype="'success'" v-if="saleSuitAddNewCount > 0">
                {{ "共 " + saleSuitAddNewCount + " 个销售套装" }}
              </p>
              <span v-fmtype="'error'" v-else>未添加销售套装</span>
              <el-button
                class="fm-ml-15"
                type="primary"
                plain
                size="mini"
                icon="el-icon-plus"
                @click="showSaleSuitAddNewPopup"
                >新增套装</el-button
              >
            </div>
          </div>
        </el-form-item>

        <template
          v-if="
            hasSaleSuit &&
            commodityInfo.saleSuitAddNewByCommodityPojoList.length > 0
          "
        >
          <el-table
            :data="commodityInfo.saleSuitAddNewByCommodityPojoList || []"
            stripe
            max-height="300px"
            style="width: 85%"
            :row-key="
              (row) => {
                return row.randomKey;
              }
            "
          >
            <el-table-column
              label="套装名称"
              width="150"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column
              label="套装内容"
              width="250"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{
                  scope.row.itemAddNewPojoList
                    .map((d) => d.specName + " x " + d.quantity)
                    .join("、")
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="售价"
              width="150"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <FmAmount :amount="scope.row.salePrice"></FmAmount>
              </template>
            </el-table-column>
            <el-table-column
              prop="frozen"
              label="冻结状态"
              header-align="center"
              width="100"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-fmtype="'danger'" v-if="scope.row.frozen">已冻结</span>
                <span v-fmtype="'success'" v-else>未冻结</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="
                    showSaleSuitEditPopup(scope.row, scope.$index)
                  "
                  type="text"
                  icon="el-icon-edit"
                >
                  编辑
                </el-button>
                <el-button
                  @click.native.stop="deleteSaleSuit(scope.row, scope.$index)"
                  type="text"
                  icon="el-icon-delete"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save"> 保 存 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="specEditIndex == null ? '新增商品规格' : '修改商品规格'"
      :visible="specEditPopupShow"
      width="600px"
      @close="specEditPopupCancel"
      v-loading="specloading"
      v-if="specEditPopupShow"
    >
      <el-form
        :model="specEditPojo"
        label-position="right"
        label-width="100px"
        ref="specEditForm"
        :rules="{
          sysFileIdList: $ruleUtil.array('规格图片', '上传', 0, 6),
          specName: $ruleUtil.simple({
            fieldName: '规格名称',
            required: true,
            max: 50,
          }),
          barCode: $ruleUtil.simple({
            fieldName: '条码',
            required: false,
            max: 50,
          }),
          nowQuantity: $ruleUtil.number('现有库存', 0),
        }"
        v-if="specEditPojo && typeof specEditPojo.specName != 'undefined'"
      >
        <el-form-item label="规格图片" class="fm-mt-10" prop="sysFileIdList">
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in specEditPojo.imageList"
            :key="index"
          >
            <el-image
              :id="'commoditySpecImage' + index"
              :src="file.url"
              :preview-src-list="specEditPojo.imageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="commoditySpecFilePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="commoditySpecFileDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadCommodityImage + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="6"
            multiple
            accept="image/*"
            :file-list="specEditPojo.imageList"
            :show-file-list="false"
            :on-change="commoditySpecFileChange"
            :on-success="commoditySpecFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传6张图片')"
            v-if="specEditPojo.imageList.length < 6"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="规格名称" prop="specName">
          <el-input
            v-model="specEditPojo.specName"
            style="width: 280px"
            placeholder="请输入规格名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="条码" prop="barCode">
          <el-input
            v-model="specEditPojo.barCode"
            style="width: 280px"
            placeholder="请输入或录入条码"
          ></el-input>
        </el-form-item>
        <template v-if="!specEditPojo.id">
          <el-form-item label="现有库存" prop="nowQuantity">
            <span v-fmtype="specEditPojo.nowQuantity > 0 ? '' : 'warning'">{{
              "合计 " + specEditPojo.nowQuantity
            }}</span>
          </el-form-item>
          <el-table
            :data="specEditPojo.specWareHouseAddNewPojoList || []"
            stripe
            :row-key="
              (row) => {
                return row.wareHouseId;
              }
            "
            :key="'orderWareHouse' + orderWareHouseKey"
            style="width: 100%"
          >
            <el-table-column
              label="仓库"
              min-width="210"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <template v-if="wareHouseList && wareHouseList.length > 1">
                  <el-select
                    :value="scope.row.wareHouseId"
                    placeholder="请选择仓库"
                    @change="
                      (value) =>
                        selectWareHousePopupConfirm(value, scope.$index)
                    "
                  >
                    <el-option
                      v-for="(item, index) in wareHouseList"
                      :key="item.id + index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
                <div style="text-align: left" v-else>
                  <span>{{ scope.row.wareHouse.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="现有库存"
              min-width="190"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <CommodityQuantityInputBox
                  v-model="scope.row.nowQuantity"
                  size="small"
                  :step="stepValue"
                  style="width: 180px"
                  @change="
                    specWareHouseNowQuantityChange(scope.$index, scope.row)
                  "
                ></CommodityQuantityInputBox>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
              v-if="wareHouseList && wareHouseList.length > 1"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="addSpecWareHouseItem(scope.$index)"
                  type="text"
                  icon="el-icon-plus"
                  :disabled="
                    specEditPojo.specWareHouseAddNewPojoList.length ==
                    wareHouseList.length
                  "
                >
                  增加
                </el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  v-fmtype="
                    specEditPojo.specWareHouseAddNewPojoList.length == 1
                      ? 'info'
                      : 'error'
                  "
                  :disabled="
                    specEditPojo.specWareHouseAddNewPojoList.length == 1
                  "
                  @click.native.stop="deleteSpecWareHouseItem(scope.$index)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-form-item
            prop="nowQuantityAmount"
            class="fm-margin-top-10"
            label="库存价值"
            required
          >
            <el-input-number
              style="width: 170px"
              v-model="specEditPojo.nowQuantityAmount"
              label="库存价值"
              size="small"
              :precision="2"
              :min="0"
              :step="1"
            ></el-input-number>
          </el-form-item>
        </template>
        <el-form-item label="采购价" v-if="$jsTool.currentUserCanSeePrice()">
          <el-input-number
            style="width: 170px"
            v-model="specEditPojo.retailPrice"
            label="采购价"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="批发价">
          <el-input-number
            style="width: 170px"
            v-model="specEditPojo.tradePrice"
            label="批发价"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="零售价">
          <el-input-number
            style="width: 170px"
            v-model="specEditPojo.buyingPrice"
            label="零售价"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="配送费">
          <el-input-number
            style="width: 170px"
            v-model="specEditPojo.distributionPrice"
            label="配送费"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="是否在产">
          <el-radio-group v-model="specEditPojo.inProduction">
            <el-radio :label="true">
              <span v-fmtype="'success'">在产</span>
            </el-radio>
            <el-radio :label="false">
              <span v-fmtype="'danger'">已停产</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="specEditPojo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="specEditPojo.extFieldValueAddNewPojoList.length > 0">
          <div style="height: 10px"></div>
          <el-divider content-position="left">
            <span style="font-weight: bold">拓展字段</span>
          </el-divider>
          <div style="height: 20px"></div>
          <el-form-item
            v-for="(item, fiIndex) in specEditPojo.extFieldValueAddNewPojoList"
            :key="fiIndex"
            :class="item.visible ? '' : 'deleteFormItem'"
            :label="item.label"
            :required="item.requiredMark && item.visible"
          >
            <span style="color: var(--fm-warning-color)" v-if="!item.visible"
              >已删除</span
            >
            <template v-else>
              <template v-if="item.extFieldTypeEnum == 'Input'">
                <el-input
                  type="text"
                  :placeholder="item.configObj.placeholder"
                  :maxlength="item.configObj.maxlength"
                  v-model="item.value"
                  show-word-limit
                  style="width: 280px"
                >
                </el-input>
              </template>
              <template v-if="item.extFieldTypeEnum == 'InputNumber'">
                <el-input-number
                  inputWidth="100"
                  v-model="item.value"
                  :placeholder="item.configObj.placeholder"
                  :max="item.configObj.max"
                  :min="item.configObj.min"
                  :step="item.configObj.step"
                  :precision="item.configObj.precision"
                ></el-input-number>
              </template>
              <template v-if="item.extFieldTypeEnum == 'Radio'">
                <el-radio-group v-model="item.value">
                  <el-radio
                    v-for="(check, index) in item.configObj.list"
                    :key="index"
                    :label="check.label"
                    :name="check.label"
                    style="height: 32px; align-content: space-around"
                  ></el-radio>
                </el-radio-group>
              </template>
              <template v-if="item.extFieldTypeEnum == 'Checkbox'">
                <el-checkbox-group v-model="item.value">
                  <el-checkbox
                    v-for="(check, index) in item.configObj.list"
                    :key="index"
                    :label="check.label"
                    :name="check.label"
                  ></el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-if="item.extFieldTypeEnum == 'Select'">
                <el-select
                  v-model="item.value"
                  :placeholder="item.configObj.placeholder"
                >
                  <el-option
                    v-for="option in item.configObj.list"
                    :key="option.no"
                    :label="option.label"
                    :value="option.label"
                  >
                  </el-option>
                </el-select>
              </template>
              <template v-if="item.extFieldTypeEnum == 'TimePicker'">
                <el-date-picker
                  v-model="item.value"
                  :type="item.configObj.format"
                  :value-format="
                    item.configObj.format == 'datetime'
                      ? 'yyyy-MM-dd HH:mm:ss'
                      : 'yyyy-MM-dd'
                  "
                >
                </el-date-picker>
              </template>
            </template>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="specEditPopupCancel">取 消</el-button>
        <el-button type="primary" @click="specEditPopupConfirm">
          保 存
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="
        saleSuitAddNewByCommodityIndex == null ? '新增销售套装' : '修改销售套装'
      "
      :visible="saleSuitAddNewPopupShow"
      width="600px"
      @close="saleSuitAddNewPopupCancel"
      v-if="saleSuitAddNewPopupShow"
    >
      <el-form
        :model="saleSuitAddNewByCommodityPojo"
        label-position="right"
        label-width="100px"
        ref="saleSuitAddNewByCommodityForm"
        :rules="{
          name: $ruleUtil.simple({
            fieldName: '套装名称',
            required: true,
            max: 20,
          }),
        }"
        v-if="
          saleSuitAddNewByCommodityPojo &&
          typeof saleSuitAddNewByCommodityPojo.name != 'undefined'
        "
      >
        <el-form-item label="套装名称" prop="name">
          <el-input
            v-model="saleSuitAddNewByCommodityPojo.name"
            style="width: 280px"
            placeholder="请输入销售套装名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="套装内容">
          <span>{{
            saleSuitAddNewByCommoditySpecList
              .filter((d) => d.quantity > 0)
              .map((d) => d.specName + " x " + d.quantity)
              .join("；") || "———"
          }}</span>
        </el-form-item>

        <el-table
          :data="saleSuitAddNewByCommoditySpecList || []"
          stripe
          style="width: 100%"
        >
          <el-table-column
            label="规格名称"
            min-width="200"
            align="center"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="fm-flex">
                <span>{{ scope.row.specName }}</span>
                <FmAmount :amount="scope.row.buyingPrice"></FmAmount>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemAmount"
            label="数量"
            min-width="200"
            align="center"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                v-model="scope.row.quantity"
                size="small"
                :step="stepValue"
                style="width: 180px"
                @change="
                  changeSaleSuitItemQuantity(scope.$index, scope.row.quantity)
                "
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item label="总零售价">
          <div class="fm-flex" style="height: 32px">
            <FmAmount
              :amount="
                $jsTool.sum(
                  saleSuitAddNewByCommoditySpecList.map(
                    (item) => item.buyingPrice * item.quantity
                  )
                )
              "
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="套装售价">
          <el-input-number
            v-model="saleSuitAddNewByCommodityPojo.salePrice"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
            style="width: 180px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="saleSuitAddNewByCommodityPojo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saleSuitAddNewPopupCancel">取 消</el-button>
        <el-button type="primary" @click="saleSuitAddNewPopupConfirm">
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FmAmount from "./fm/FmAmount.vue";
export default {
  components: { FmAmount },
  name: "Fmerpv2WebCommodityEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    commodityId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.$nextTick(async () => {
              this.getExtFieldList();
              this.getWareHouseList();
            });
          }, 100);
        }
        this.$nextTick(() => {
          this.$refs.editFormRef.clearValidate();
        });
      },
      immediate: true,
    },
    commodityId: {
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.getCommodityInfo();
          }, 100);
        }
      },
      immediate: true,
    },
  },
  computed: {
    // saleSuitAddNewCount() {
    //   console.log(
    //     "this.commodityInfo.saleSuitAddNewByCommodityPojoList",
    //     this.commodityInfo.saleSuitAddNewByCommodityPojoList.length
    //   );
    //   return this.commodityInfo.saleSuitAddNewByCommodityPojoList.length || 0;
    // },
  },
  data() {
    return {
      id: null,
      loading: false,
      specloading: false,
      supplierInfo: {},
      commodityCategoryInfo: {},
      commodityInfo: {
        sysFileIdList: [],
        name: "",
        commodityCategoryId: null,
        color: "无",
        unit: "个",
        supplierId: "",
        frozen: false,
        specAddNewPojoList: [],
        saleSuitAddNewByCommodityPojoList: [],
        specWareHouseAddNewPojoList: [],
      },
      imageList: [],

      hasSaleSuit: false,
      saleSuitAddNewPopupShow: false,
      saleSuitAddNewByCommodityIndex: 0,
      saleSuitAddNewByCommodityPojo: {},
      // 套装规格popup内显示的可选择规格list
      saleSuitAddNewByCommoditySpecList: null,

      specEditPopupShow: false,
      specEditIndex: 0,
      specEditPojo: {},

      // 拓展字段
      extFieldList: [],

      selectWareHousePopupShow: false,
      selectWareHousePopupIndex: -1,
      wareHouseList: [],

      orderWareHouseKey: "null",

      saleSuitAddNewCount: 0,

      stepValue: 1,
    };
  },
  mounted() {},
  methods: {
    changeSaleSuitItemQuantity(index, value) {
      this.saleSuitAddNewByCommoditySpecList.splice(index, 1, {
        ...this.saleSuitAddNewByCommoditySpecList[index],
        quantity: value || 0,
      });
      this.saleSuitAddNewByCommodityPojo.salePrice = this.$jsTool.sum(
        this.saleSuitAddNewByCommoditySpecList.map(
          (item) => item.buyingPrice * item.quantity
        )
      );
    },
    saleSuitAddNewPopupConfirm() {
      let that = this;
      this.$refs.saleSuitAddNewByCommodityForm
        .validate()
        .then(async (validateRes) => {
          that.saleSuitAddNewByCommodityPojo.itemAddNewPojoList =
            that.saleSuitAddNewByCommoditySpecList.filter(
              (d) => d.quantity > 0
            );
          if (
            !that.saleSuitAddNewByCommodityPojo.itemAddNewPojoList ||
            that.saleSuitAddNewByCommodityPojo.itemAddNewPojoList.length == 0
          ) {
            this.$message.error("最少选择一个商品规格");
            return;
          }
          if (
            Number(
              this.$jsTool.sum(
                that.saleSuitAddNewByCommodityPojo.itemAddNewPojoList.map(
                  (item) => this.$jsTool.multi(item.buyingPrice, item.quantity)
                )
              )
            ) < Number(that.saleSuitAddNewByCommodityPojo.salePrice)
          ) {
            this.$message.error("套装售价不得大于总零售价");
            return;
          }
          this.saleSuitAddNewByCommodityPojo.randomKey = Math.random();
          if (that.saleSuitAddNewByCommodityIndex == null) {
            that.commodityInfo.saleSuitAddNewByCommodityPojoList.push(
              that.saleSuitAddNewByCommodityPojo
            );
          } else {
            that.commodityInfo.saleSuitAddNewByCommodityPojoList.splice(
              that.saleSuitAddNewByCommodityIndex,
              1,
              that.saleSuitAddNewByCommodityPojo
            );
          }
          this.saleSuitAddNewCount =
            this.commodityInfo.saleSuitAddNewByCommodityPojoList.length;
          that.saleSuitAddNewPopupShow = false;
          that.hasSaleSuit = true;
        })
        .catch((errors) => {});
    },
    saleSuitAddNewPopupCancel() {
      let that = this;
      this.$confirm(
        "取消将不会把修改的信息应用到商品，是否继续？",
        "操作提醒",
        {
          confirmButtonText: "继续取消",
          cancelButtonText: "返回修改",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        }
      )
        .then(() => {
          that.saleSuitAddNewPopupShow = false;
          if (
            this.commodityInfo.saleSuitAddNewByCommodityPojoList.length <= 0
          ) {
            this.hasSaleSuit = false;
          }
        })
        .catch(() => {});
    },
    handleHasSaleSuit(e) {
      if (e) {
        if (
          this.commodityInfo.specAddNewPojoList.filter((d) => d.specName)
            .length == 0
        ) {
          this.$message.error("请先填写商品规格");
          this.hasSaleSuit = false;
          return;
        }
        if (
          this.commodityInfo.saleSuitAddNewByCommodityPojoList &&
          this.commodityInfo.saleSuitAddNewByCommodityPojoList.length > 0
        ) {
          return;
        }
        this.showSaleSuitAddNewPopup();
      } else {
        this.hasSaleSuit = false;
      }
    },
    deleteSaleSuit(item, index) {
      let that = this;
      this.$confirm("是否删除销售套装" + item.name + "？", "操作提醒", {
        confirmButtonText: "继续删除",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      })
        .then(() => {
          this.commodityInfo.saleSuitAddNewByCommodityPojoList.splice(index, 1);
          this.saleSuitAddNewCount =
            this.commodityInfo.saleSuitAddNewByCommodityPojoList.length;
          if (
            this.commodityInfo.saleSuitAddNewByCommodityPojoList.length <= 0
          ) {
            this.hasSaleSuit = false;
          }
        })
        .catch(() => {});
    },
    showSaleSuitAddNewPopup() {
      if (
        this.commodityInfo.specAddNewPojoList.filter((d) => d.specName)
          .length == 0
      ) {
        this.$message.error("请先填写商品规格");
        return;
      }
      if (
        !this.hasSaleSuit &&
        this.commodityInfo.saleSuitAddNewByCommodityPojoList &&
        this.commodityInfo.saleSuitAddNewByCommodityPojoList.length > 0
      ) {
        this.hasSaleSuit = true;
        return;
      }
      let saleSuitAddNewByCommoditySpecList =
        this.commodityInfo.specAddNewPojoList
          .filter((d) => d.specName)
          .map((d, index) => {
            return {
              itemNo: index,
              quantity: 0,
              specName: d.specName,
              buyingPrice: d.buyingPrice,
            };
          });
      this.saleSuitAddNewByCommoditySpecList =
        saleSuitAddNewByCommoditySpecList;
      this.saleSuitAddNewByCommodityPojo = {
        imageList: [],
        name: "",
        salePrice: "0.00",
        frozen: false,
        itemAddNewPojoList: [],
      };
      this.saleSuitAddNewByCommodityIndex = null;
      this.saleSuitAddNewPopupShow = true;
    },
    showSaleSuitEditPopup(item, index) {
      if (
        this.commodityInfo.specAddNewPojoList.filter((d) => d.specName)
          .length == 0
      ) {
        this.$message.error("请先填写商品规格");
        return;
      }
      let saleSuitAddNewByCommoditySpecList =
        this.commodityInfo.specAddNewPojoList
          .filter((d) => d.specName)
          .map((d) => {
            return {
              itemNo: index,
              quantity: 0,
              specName: d.specName,
              buyingPrice: d.buyingPrice,
            };
          });
      saleSuitAddNewByCommoditySpecList = saleSuitAddNewByCommoditySpecList.map(
        (listItem) => {
          let a = item.itemAddNewPojoList.filter(
            (d) => d.specName == listItem.specName
          );
          if (a.length > 0) {
            return {
              ...listItem,
              quantity: a[0].quantity,
            };
          } else {
            return listItem;
          }
        }
      );
      this.saleSuitAddNewByCommoditySpecList =
        saleSuitAddNewByCommoditySpecList;
      this.saleSuitAddNewByCommodityPojo = JSON.parse(JSON.stringify(item));
      this.saleSuitAddNewByCommodityPojo.imageList = item.imageList.map(
        (item) => {
          return {
            ...item,
            imageName: item.sysFile.name,
            id: item.sysFile.id,
            message: "已有图片",
            status: "success",
            thumb: item.sysFile.prefix + item.sysFile.name,
            type: "image",
            url: item.sysFile.prefix + item.sysFile.name,
          };
        }
      );
      this.saleSuitAddNewByCommodityIndex = index || 0;
      this.saleSuitAddNewPopupShow = true;
    },
    // 选择仓库
    showSelectWareHousePopup(index) {
      this.wareHouseList = this.canSelectWareHouseListBySpec(
        this.specEditPojo.relatedSaleOrderItem.commoditySpec
      );
      this.orderWareHouseKey = Math.random();
      this.selectWareHousePopupIndex = index;
      this.selectWareHousePopupShow = true;
    },
    selectWareHousePopupConfirm(item, selectWareHousePopupIndex) {
      if (item) {
        let wareHouse = this.wareHouseList.find((e) => e.id == item);
        let selectIndex =
          this.specEditPojo.specWareHouseAddNewPojoList.findIndex(
            (d) => d.wareHouseId && d.wareHouseId == item
          );
        if (selectIndex > -1) {
          this.$message.error("请勿重复选择仓库");
          this.selectWareHousePopupShow = false;
          return;
        }
        this.specEditPojo.specWareHouseAddNewPojoList[
          selectWareHousePopupIndex
        ].wareHouse = wareHouse;
        this.specEditPojo.specWareHouseAddNewPojoList[
          selectWareHousePopupIndex
        ].wareHouseId = wareHouse.id;
        this.orderWareHouseKey = Math.random();
        this.selectWareHousePopupShow = false;
      }
    },
    specWareHouseNowQuantityChange() {
      this.specEditPojo.nowQuantity = Number(
        this.$jsTool.sumQuantity(
          this.specEditPojo.specWareHouseAddNewPojoList.map(
            (d) => d.nowQuantity || 0
          )
        )
      );
    },
    addSpecWareHouseItem(index) {
      this.specEditPojo.specWareHouseAddNewPojoList.splice(index + 1, 0, {
        nowQuantity: 0,
      });
      this.orderWareHouseKey = Math.random();
      this.specWareHouseNowQuantityChange();
    },
    deleteSpecWareHouseItem(index) {
      let that = this;
      this.$confirm("确认删除所选仓库信息？", "操作提醒", {
        confirmButtonText: "继续删除",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      })
        .then(() => {
          that.specEditPojo.specWareHouseAddNewPojoList.splice(index, 1);
          this.orderWareHouseKey = Math.random();
          that.specWareHouseNowQuantityChange();
        })
        .catch(() => {});
    },
    async deleteSpec(item, index) {
      let that = this;
      if (item.id) {
        let res = await this.$api.commoditySnapshot_commoditySpecUsed(item.id, {
          showLoading: true,
          loadingParam: {
            target: "#editDialog > *",
            lock: true,
            text: "加载中...",
          },
        });
        if (res && res.success && res.data > 0) {
          this.$alert(
            "规格" + item.specName + "已被单据使用，无法删除，如不再需要请冻结",
            "操作提醒",
            { confirmButtonText: "确定" }
          );
          return;
        }
      }
      this.$confirm("是否删除规格" + item.specName + "？", "操作提醒", {
        confirmButtonText: "继续删除",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      }).then(() => {
        that.commodityInfo.specAddNewPojoList.splice(index, 1);
      });
    },
    showSpecAddNewPopup() {
      this.loading = true;
      let wareHouse = null;
      if (this.wareHouseList && this.wareHouseList.length == 1) {
        wareHouse = this.wareHouseList[0];
      }
      this.specEditPojo = {
        sysFileIdList: [],
        imageList: [],
        specName: "",
        nowQuantity: 0,
        nowQuantityAmount: "0.00",
        buyingPrice: "0.00",
        retailPrice: "0.00",
        tradePrice: "0.00",
        distributionPrice: "0.00",
        inProduction: true,
        frozen: false,
        extFieldValueAddNewPojoList: JSON.parse(
          JSON.stringify(this.extFieldList || [])
        ),
        specWareHouseAddNewPojoList: [
          {
            wareHouse: wareHouse || null,
            wareHouseId: wareHouse ? wareHouse.id : null,
            nowQuantity: 0,
          },
        ],
      };
      this.specEditIndex = null;
      this.specEditPopupShow = true;
      this.loading = false;
    },
    showSpecEditPopup(item, index) {
      this.specloading = true;
      this.specEditPojo = JSON.parse(JSON.stringify(item));
      this.specEditPojo.imageList = item.imageList.map((item) => {
        if (item.sysFile) {
          return {
            ...item,
            imageName: item.sysFile.name,
            id: item.sysFile.id,
            message: "已有图片",
            status: "success",
            thumb: item.sysFile.prefix + item.sysFile.name,
            type: "image",
            url: item.sysFile.prefix + item.sysFile.name,
          };
        } else {
          return {
            ...item,
            imageName: item.name,
            id: item.id,
            message: "已有图片",
            status: "success",
            thumb: item.url,
            type: "image",
            url: item.url,
          };
        }
      });
      for (let item of this.specEditPojo.extFieldValueAddNewPojoList) {
        if (item.extFieldTypeEnum == "Checkbox") {
          if (item.value) {
            if (typeof item.value == "string") {
              item.value = item.value.split(",");
            }
          } else {
            item.value = [];
          }
        }
      }
      this.specEditIndex = index || 0;
      this.specEditPopupShow = true;
      setTimeout(() => {
        this.specloading = false;
      }, 100);
    },
    specEditPopupCancel() {
      let that = this;
      this.$confirm(
        "取消将不会把修改的信息应用到商品，是否继续？",
        "操作提醒",
        {
          confirmButtonText: "继续取消",
          cancelButtonText: "返回修改",
          type: "success",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        }
      )
        .then(() => {
          that.specEditPojo = {};
          that.specEditPopupShow = false;
        })
        .catch(() => {});
    },
    specEditPopupConfirm() {
      let that = this;
      this.$refs.specEditForm
        .validate()
        .then(async (validateRes) => {
          this.specloading = true;
          // if (
          //   !this.specEditPojo.id &&
          //   Number(this.specEditPojo.nowQuantityAmount) == 0
          // ) {
          //   that.specloading = false;
          //   that.$message.error("库存价值不能为零！");
          //   return;
          // }
          // 校验仓库
          if (
            this.specEditPojo.specWareHouseAddNewPojoList &&
            this.specEditPojo.specWareHouseAddNewPojoList.length > 0 &&
            this.specEditPojo.specWareHouseAddNewPojoList.some(
              (item) => !item.wareHouseId
            )
          ) {
            that.specloading = false;
            this.$message({
              message: "请选择仓库后重试！",
              type: "error",
            });
            return;
          }
          // if (
          //   this.specEditPojo.specWareHouseAddNewPojoList.some(
          //     (item) => Number(item.nowQuantity) < 0
          //   )
          // ) {
          //   that.specloading = false;
          //   this.$message({
          //     message: "请填写仓库现有库存不得小于0",
          //     type: "error",
          //   });
          //   return;
          // }
          // 校验拓展字段是否填写
          for (let item of that.specEditPojo.extFieldValueAddNewPojoList) {
            if (item.requiredMark && item.visible && item.value == null) {
              that.specloading = false;
              that.$message.error("请完善拓展字段" + item.label);
              return;
            }
          }
          that.specEditPojo.extFieldValueAddNewPojoList =
            that.specEditPojo.extFieldValueAddNewPojoList.filter(
              (d) => d.visible
            );
          for (let item of that.specEditPojo.extFieldValueAddNewPojoList) {
            if (
              (item.extFieldTypeEnum == "Checkbox" ||
                item.extFieldTypeEnum == "Radio") &&
              item.value
            ) {
              item.value = item.value.toString();
            }
            item.extFieldId = item.id;
          }
          if (that.specEditIndex == null) {
            that.commodityInfo.specAddNewPojoList.push(that.specEditPojo);
          } else {
            that.commodityInfo.specAddNewPojoList.splice(
              that.specEditIndex,
              1,
              that.specEditPojo
            );
          }
          that.specloading = false;
          that.specEditPojo = {};
          that.specEditPopupShow = false;
        })
        .catch((errors) => {});
    },
    // 选择商品分类
    selectCommodityCategory(commodityCategory) {
      this.commodityCategoryInfo = commodityCategory;
      this.commodityInfo.commodityCategoryId = commodityCategory.id;
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.validateField("commodityCategoryId");
        }
      });
    },
    // 选择供应商
    selectSupplier(supplier) {
      this.supplierInfo = supplier;
      this.commodityInfo.supplierId = supplier.id;
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.validateField("supplierId");
        }
      });
    },
    // 商品图片有关
    commodityFilePreview(index) {
      document.getElementById("commodityImage" + index).click();
    },
    commodityFileDelete(index, file) {
      this.imageList.splice(index, 1);
      this.initCommoditySysFileIdList();
    },
    commodityFileChange(file, fileList) {
      if (file.status == "ready") {
        this.imageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initCommoditySysFileIdList();
    },
    commodityFileSuccess(res, file, fileList) {
      let index = this.imageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.imageList.splice(index, 1, {
          ...this.imageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.imageList.splice(index, 1);
      }
      this.initCommoditySysFileIdList();
    },
    initCommoditySysFileIdList() {
      this.$nextTick(() => {
        this.commodityInfo.sysFileIdList = this.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editFormRef.validateField("sysFileIdList");
      });
    },

    // 商品规格图片有关
    commoditySpecFilePreview(index) {
      document.getElementById("commoditySpecImage" + index).click();
    },
    commoditySpecFileDelete(index, file) {
      this.specEditPojo.imageList.splice(index, 1);
      this.initCommoditySpecSysFileIdList();
    },
    commoditySpecFileChange(file, fileList) {
      if (file.status == "ready") {
        this.specEditPojo.imageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initCommoditySpecSysFileIdList();
    },
    commoditySpecFileSuccess(res, file, fileList) {
      let index = this.specEditPojo.imageList.findIndex(
        (d) => d.uid == file.uid
      );
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.specEditPojo.imageList.splice(index, 1, {
          ...this.specEditPojo.imageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.specEditPojo.imageList.splice(index, 1);
      }
      this.initCommoditySpecSysFileIdList();
    },
    initCommoditySpecSysFileIdList() {
      this.$nextTick(() => {
        this.specEditPojo.sysFileIdList = this.specEditPojo.imageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.specEditForm.validateField("sysFileIdList");
      });
    },

    async save() {
      this.$refs.editFormRef
        .validate()
        .then(async (validateRes) => {
          if (!this.hasSaleSuit) {
            this.commodityInfo.saleSuitAddNewByCommodityPojoList = [];
          }
          let param = {
            ...this.commodityInfo,
            specAddNewPojoList: this.commodityInfo.specAddNewPojoList,
          };
          let res = this.commodityId
            ? await this.$api.commodity_update(param, {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "更新中...",
                },
              })
            : await this.$api.commodity_addNew(param, {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              });
          if (res && res.success) {
            setTimeout(() => {
              this.close(true);
            }, 1000);
          }
        })
        .catch((errors) => {});
    },

    async getExtFieldList() {
      let res = await this.$api.extField_findAvailableList("CommoditySpec");
      if (res && res.success) {
        this.extFieldList = this.$jsTool.handleExtFiledRes(res.data);
      }
    },
    async getWareHouseList(args) {
      let res = await this.$api.wareHouse_findListForSelect(args);
      if (res && res.success) {
        this.wareHouseList = res.data;
      }
    },
    async getCommodityInfo(args) {
      this.loading = true;
      let res = await this.$api.commodity_findVoById(this.commodityId, args);
      if (res && res.success) {
        // 初始化数据
        this.commodityInfo = {
          ...res.data.commodity,
          commoditySpecList: res.data.commoditySpecList,
          commoditySaleSuitList: res.data.commoditySaleSuitList || [],
          sysFileIdList: res.data.commodity.imageList.map((item) => item.sysFile.id),
        };
        this.imageList = res.data.commodity.imageList.map((item) => {
          return {
            imageName: item.sysFile.name,
            id: item.sysFile.id,
            message: "已有图片",
            status: "success",
            thumb: item.sysFile.prefix + item.sysFile.name,
            type: "image",
            url: item.sysFile.prefix + item.sysFile.name,
            sysFile: item.sysFile,
          };
        });
        this.supplierInfo = res.data.commodity.supplier;
        this.commodityCategoryInfo = res.data.commodity.commodityCategory;
        this.commodityInfo.specAddNewPojoList = res.data.commoditySpecList.map(
          (d) => {
            let item = d;
            let extFieldValueAddNewPojoList = [];
            // 处理拓展字段
            for (let extFieldItem of this.extFieldList) {
              let value = extFieldItem.value;
              if (item.extFieldValueList && item.extFieldValueList.length > 0) {
                let extFieldValueAddNewIndex = item.extFieldValueList.findIndex(
                  (d) => d.code == extFieldItem.code
                );
                let extFieldValueAddNewItem =
                  item.extFieldValueList[extFieldValueAddNewIndex];
                if (extFieldValueAddNewIndex > -1) {
                  value =
                    extFieldItem.extFieldTypeEnum ==
                      extFieldValueAddNewItem.extFieldTypeEnum.Name ||
                    extFieldItem.extFieldTypeEnum ==
                      extFieldValueAddNewItem.extFieldTypeEnum
                      ? extFieldValueAddNewItem.value
                      : null;
                  if (
                    extFieldItem.extFieldTypeEnum == "Checkbox" ||
                    extFieldItem.extFieldTypeEnum.Name == "Checkbox"
                  ) {
                    if (value) {
                      if (typeof value == "string") {
                        value = value.split(",");
                      }
                    } else {
                      value = [];
                    }
                  }
                }
              }
              extFieldValueAddNewPojoList.push({
                ...JSON.parse(JSON.stringify(extFieldItem)),
                value: value,
              });
            }
            return {
              ...item,
              extFieldValueAddNewPojoList: extFieldValueAddNewPojoList,
              sysFileIdList: d.imageList.map((item) => item.sysFile.id),
            };
          }
        );
        this.commodityInfo.saleSuitAddNewByCommodityPojoList =
          res.data.commoditySaleSuitList.map((d) => {
            return {
              ...d,
              randomKey: Math.random(),
              sysFileIdList: d.imageList.map((item) => item.sysFile.id),
              itemAddNewPojoList: this.handleSaleSuitItem(
                d.commoditySaleSuitItemList
              ),
            };
          });
        this.saleSuitAddNewCount =
          this.commodityInfo.saleSuitAddNewByCommodityPojoList.length;
        if (
          this.commodityInfo.saleSuitAddNewByCommodityPojoList &&
          this.commodityInfo.saleSuitAddNewByCommodityPojoList.length > 0
        ) {
          this.hasSaleSuit = true;
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
    handleSaleSuitItem(commoditySaleSuitItemList) {
      return commoditySaleSuitItemList.map((item) => {
        if (
          this.commodityInfo.specAddNewPojoList &&
          this.commodityInfo.specAddNewPojoList.length > 0
        ) {
          let spec = this.commodityInfo.specAddNewPojoList.filter(
            (d) => d.id == item.commoditySpecId
          );
          if (spec && spec.length > 0) {
            return {
              ...item,
              specName: spec[0].specName,
              buyingPrice: spec[0].buyingPrice,
            };
          }
        }
        return {
          ...item,
          specName: "未知规格",
          buyingPrice: "0.00",
        };
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/CommodityEditDialog.vue